module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-2x1-679116ab08828a80b6c80ee3f14a5301.jpg";